/**
 * Created by Stefann on 29/03/2019.
 */
import {ArrayAccessDictionary} from "@/lib/ArrayAccessDictionary";

export class IconRegistry {
    public static icons: ArrayAccessDictionary<any> = {
        branch: {
            "auto": 'car.svg',
            "auto-pro": 'car.svg',
            "sante": 'stethoscope.svg',
            "sante-particulier": 'stethoscope.svg',
            "sante-pro": 'stethoscope.svg',
            "autres-risques-technique": 'autres-risques-techniques.svg',
            "individuel-accident": 'broken-arm.svg',
            "responsabilite-civile-pro": 'responsabilite-civile-pro.svg',
            "habitation": 'home.svg',
            "voyage": 'airplane.svg',
            'multirisque-pro-et-rc': 'handshake.svg',
            'responsabilite-civile-pro-multirisque-pro': 'responsabilite-civile-pro.svg',
            'multirisque-pro': 'handshake.svg',
            'sante-enterprise': 'stethoscope.svg',
            'auto-enterprise': 'car.svg',
            "transport": 'transport.svg',
            "rc-scolaire": "mortarboard.svg",
            "accident-de-la-vie": "broken-arm.svg",
            "epargne": "wallet.svg",
            "vie-et-epargne-pro": "wallet.svg",
            "tous-risque-chantier": "handshake.svg",
            "individuel-accident-groupe": "slipping.svg",
        },
        guarantee: {
            1: '1.png',
            2: '2.png',
            3: '3.png',
            4: '4.png',
            5: '5.png',
            6: '6.png',
            7: '7.png',
            8: '8.png',
            9: '9.png',
        },
        choices: {
            26: {
                MRH2: 'house.svg',
                MRH1: 'building.svg',
            },
            8: {
                UV2: false,
                UV3: false,
                UV4: false,
            },
            // 10: {
            //     YES: false,
            //     NO: false,
            // },
            // 15: {
            //     P2: false,
            //     P1: false,
            // },
            // 119: {
            //     UV6: false,
            //     UV7: false,
            // },
            212: {
                MRP1: false,
                MRP2: false,
                MRP3: false,
                MRP4: false,
            },
            // 230: {
            //     MRP25: false,
            //     MRP26: false,
            //     MRP27: false,
            // },
            // 232: {
            //     MRP28: false,
            //     MRP29: false,
            //     MRP30: false,
            //     MRP31: false,
            // },
            213: {
                MRP5: false,
                MRP6: false,
                MRP7: false,
                MRP8: false,
                MRP9: false,
                MRP10: false,
                MRP11: false,
                MRP12: false,
                MRP36: false,
                MRP37: false,
            },
            194: {
                MRP: 'mrp-icon.svg',
                RCP: 'rcp-icon.svg',
            },
            267: {
                AUP1: 'saisie.svg',
                AUP2: 'excel-icon.svg',
            },
            39: {
                MRH11: false,
                MRH12: false,
                MRH13: false,
                MRH14: false,
                MRH15: false,
                MRH16: false,
                MRH17: false
            },
            118: {
                EDU1: false,
                EDU2: false,
            },
            146: {
                DUR1: false,
                DUR2: false,
                DUR3: false,
                DUR4: false,
            },

            4: {
                C1: 'essence.svg',
                C2: 'diesel.svg',
                C3: 'hybride.svg',
            },
            18: {
                1: 'berline.svg',
                2: 'camionnette.svg',
                3: 'moto.svg',
                P1: 'berline.svg',
                P2: 'camionnette.svg',
                M1: 'moto.svg',

            },
        },
    };

    public static getIcon(group: string|number, name: string|number) {
        return IconRegistry.icons[group][name];
    }

    public static getChoiceIcon(questionId: number, choiceCode: string){
        return IconRegistry.icons["choices"][questionId][choiceCode];
    }

    public static questionHasChoiceIcons(questionId: number) {
        return typeof IconRegistry.icons["choices"][questionId] !== typeof undefined;
    }
}
